import * as React from 'react';
const LinkContext = React.createContext(undefined);
export const linkContextDefaultValue = {
  inline: false
};
export const LinkContextProvider = LinkContext.Provider;
export const useLinkContext = () => {
  var _React_useContext;
  return (_React_useContext = React.useContext(LinkContext)) !== null && _React_useContext !== void 0 ? _React_useContext : linkContextDefaultValue;
};